import React from "react";
import "./App.css";
import IndexPage from "./pages";

function App() {
    return (
        <div className="App">
            <IndexPage />
        </div>
    );
}

export default App;
